/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Typography,
  Button,
  Tab,
  Tabs,
  Dialog,
  DialogTitle,
  DialogContent,
  Select,
  FormControl,
  MenuItem,
  InputLabel,
  TextField,
  IconButton,
  FormControlLabel,
  Radio,
  RadioGroup,
  Checkbox,
  FormGroup,
  Chip,
  Stack,
  FormHelperText,
  DialogActions,
  Autocomplete,
  InputAdornment,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Textarea } from "@mui/joy";
import _debounce from "lodash/debounce";
import DeleteIcon from "@mui/icons-material/Delete";
import InfoIcon from "@mui/icons-material/Info";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import CloseIcon from "@mui/icons-material/Close";
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";
import ReactQuill from "react-quill";
import API from "../../Utils/Interceptor/ApiMiddleware";
import CustomSnackbar from "../../components/Composables/CustomSnackBarMenu";

function AddJob({ open, closePopup, data, jobId, fetchJobsGridData }) {
  const [tabValue, setTabValue] = useState(0);
  const [formData, setFormData] = useState({
    employer: "",
    email: "",
    user_id: "",
    company: "",
    branch_id: "",
    branch: "",
    category: "",
    jobTitle: "",
    jobType: "",
    openings: "",
    duration: "",
    rate: "",
    salary: "",
    minexperience: "",
    maxexperience: "",
    workMode: "On-Site",
    visibility: 1,
    state: "",
    city: "",
    description: "",
    skills: [],
    coverLetter: 0,
    notes: "",
  });
  const [questions, setQuestions] = useState([]);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  const [fetchedCitiesStates, setFetchedCitiesStates] = useState({});
  const [skillInput, setSkillInput] = useState("");

  const [skillsOption, setSkillsOption] = useState([]);

  const [apiData, setApiData] = useState({
    employersName: [],
    statesData: [],
    citiesData: [],
    companiesData: [],
    branchesData: [],
    categoriesData: [],
  });

  const [errors, setErrors] = useState({});

  const jobTypeMapping = {
    Hire: "H",
    Contract: "C",
    "Contract to Hire": "C2H",
    Freelance: "F",
  };

  const numericFields = [
    "minexperience",
    "maxexperience",
    "openings",
    "duration",
    "rate",
    "salary",
  ];

  // const handleChange = (event) => {
  //   const { name, value, type, checked } = event.target;

  //   let updatedValue = value;

  //   if (type === "checkbox" && name === "visibility") {
  //     updatedValue = checked ? 1 : 0;
  //   } else if (numericFields.includes(name)) {
  //     updatedValue = value.replace(/\D/g, "");
  //     if (name === "openings" && parseInt(updatedValue) > 1000) {
  //       updatedValue = "1000";
  //     } else if (updatedValue.length > 10) {
  //       updatedValue = updatedValue.slice(0, 10);
  //     }
  //   } else if (name === "jobType") {
  //     updatedValue = jobTypeMapping[value] || value;
  //   }

  //   if (name === "minexperience" || name === "maxexperience") {
  //     updatedValue = updatedValue
  //       ? Math.min(parseInt(updatedValue), 40).toString()
  //       : "";
  //   }

  //   setFormData((prev) => {
  //     let newFormData = { ...prev, [name]: updatedValue };
  //     let newErrors = { ...errors };

  //     if (newFormData.minexperience && newFormData.maxexperience) {
  //       if (
  //         parseInt(newFormData.maxexperience) <
  //         parseInt(newFormData.minexperience)
  //       ) {
  //         newErrors.maxexperience =
  //           "Maximum experience cannot be less than Minimum experience";
  //       } else if (
  //         parseInt(newFormData.maxexperience) ===
  //         parseInt(newFormData.minexperience)
  //       ) {
  //         newErrors.maxexperience =
  //           "Maximum experience cannot be equal to Minimum experience";
  //       }
  //       else {
  //         delete newErrors.maxexperience;
  //       }
  //     }

  //     setErrors(newErrors);
  //     return newFormData;
  //   });
  // };
  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;

    let updatedValue = value;

    if (type === "checkbox" && name === "visibility") {
      updatedValue = checked ? 1 : 0;
    } else if (numericFields.includes(name)) {
      updatedValue = value.replace(/\D/g, "");
      if (name === "openings" && parseInt(updatedValue) > 1000) {
        updatedValue = "1000";
      } else if (updatedValue.length > 10) {
        updatedValue = updatedValue.slice(0, 10);
      }
    } else if (name === "jobType") {
      updatedValue = jobTypeMapping[value] || value;
    }

    if (name === "minexperience" || name === "maxexperience") {
      updatedValue = updatedValue
        ? Math.min(parseInt(updatedValue), 40).toString()
        : "";
    }

    setFormData((prev) => {
      let newFormData = {
        ...prev,
        [name]: updatedValue,
        ...(name === "state" && { city: "" }),
      };

      if (name === "jobType" && updatedValue === "H") {
        newFormData.duration = "";
      }
      if (name === "jobType" && updatedValue !== "H") {
        newFormData.salary = "";
      }
      let newErrors = { ...errors };

      if (newFormData[name]) {
        delete newErrors[name];
      }

      if (newFormData.minexperience && newFormData.maxexperience) {
        if (
          parseInt(newFormData.maxexperience) <
          parseInt(newFormData.minexperience)
        ) {
          newErrors.maxexperience =
            "Maximum experience cannot be less than Minimum experience";
        } else if (
          parseInt(newFormData.maxexperience) ===
          parseInt(newFormData.minexperience)
        ) {
          newErrors.maxexperience =
            "Maximum experience cannot be equal to Minimum experience";
        } else {
          delete newErrors.maxexperience;
        }
      } else {
        delete newErrors.maxexperience;
      }

      setErrors(newErrors);
      return newFormData;
    });
  };

  const getTypeIdFromLabel = (label) => {
    if (label === "Description") return 1;
    if (label === "Numeric") return 2;
    if (label === "Yes/No") return 3;
    return 1;
  };

  const addQuestion = (label) => {
    const newQuestion = {
      type: label,
      question: "",
      isCreate: true,
      isDelete: false,
      isEdit: false,
      isRequired: true,
      values:
        label === "Yes/No"
          ? [
              { name: "yes", isDefault: true },
              { name: "no", isDefault: false },
            ]
          : [],
    };
    setQuestions((prev) => [...prev, newQuestion]);
  };

  const updateQuestion = (index, key, value) => {
    setQuestions((prev) =>
      prev.map((q, i) => {
        if (i !== index) return q;

        const updated = { ...q, [key]: value };

        if (!q.isCreate) {
          updated.isEdit = true;
        }

        return updated;
      })
    );
  };

  const deleteQuestion = (index) => {
    setQuestions((prev) =>
      prev
        .map((q, i) => {
          if (i !== index) return q;

          if (q.isCreate) {
            return null;
          } else {
            return { ...q, isDelete: true, isEdit: false };
          }
        })
        .filter(Boolean)
    );
  };

  const handledescriptionOnChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      description: value,
    }));

    setErrors((prev) => ({
      ...prev,
      description: "",
    }));
  };

  const validateTabOne = () => {
    let newErrors = {};

    if (!formData.user_id) newErrors.employer = "Employer is required";
    if (!formData.company) newErrors.company = "Company is required";
    if (!formData.branch_id) newErrors.branch = "Branch is required";
    if (!formData.category) newErrors.category = "Category is required";
    if (!formData.jobTitle) newErrors.jobTitle = "Job Title is required";
    if (!formData.jobType) newErrors.jobType = "Job Type is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const validateTabTwo = () => {
    let newErrors = {};

    if (!formData.minexperience)
      newErrors.minexperience = "Min Experience is required";
    // if (!formData.maxexperience)
    //   newErrors.maxexperience = "Max Experience is required";
    if (formData.minexperience && formData.maxexperience) {
      const min = parseInt(formData.minexperience);
      const max = parseInt(formData.maxexperience);

      if (max < min) {
        newErrors.maxexperience =
          "Maximum experience cannot be less than Minimum experience";
      } else if (max === min) {
        newErrors.maxexperience =
          "Maximum experience cannot be equal to Minimum experience";
      }
    }
    if (!formData.state) newErrors.state = "State is required";
    if (!formData.city) newErrors.city = "City is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const validateTabThree = () => {
    let newErrors = {};

    if (!formData.description || formData.description === "<p><br></p>") {
      newErrors.description = "Description is required";
    }

    if (!formData.skills || formData.skills.length === 0) {
      newErrors.skills = "Skills are required";
    } else if (formData.skills.length < 5) {
      newErrors.skills = "Minimum 5 skills are required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const closeForm = () => {
    setFormData({
      employer: "",
      company: "",
      category: "",
      jobTitle: "",
      jobType: "",
      openings: "",
      duration: "",
      rate: "",
      salary: "",
      minexperience: "",
      maxexperience: "",
      workMode: "On-Site",
      visibility: 0,
      state: "",
      city: "",
      description: "",
      skills: "",
      notes: "",
    });
    setQuestions([]);
    setErrors({});
    closePopup();
    setTabValue(0);
  };

  const fetchCategoriesData = async () => {
    try {
      const response = await API.get("/job/get-job-categories");
      setApiData((prevData) => ({
        ...prevData,
        categoriesData: response?.data?.data || [],
      }));
    } catch (error) {
      console.error("Error fetching categories data", error);
    }
  };

  const handleCheckboxChange = (event) => {
    setFormData((prevData) => ({
      ...prevData,
      coverLetter: event.target.checked ? 1 : 0,
    }));
  };

  const fetchStatesData = async () => {
    try {
      const response = await API.post(
        process.env.REACT_APP_JOBEZEURL + "state-city/list",
        {}
      );
      setApiData((prevData) => ({
        ...prevData,
        statesData: response?.data?.message || [],
      }));
    } catch (error) {
      console.error("Error fetching state-city data", error);
    }
  };

  const hanldeSkillInputChange = _debounce((value) => {
    skillssearch(value);
  }, 415);

  const skillssearch = async (val) => {
    try {
      if (val) {
        const response = await API.get("/candidate/all-skills?search=" + val);
        setSkillsOption(response.data.data.map((item) => item.label));
      }
    } catch (error) {
      console.error("Error", error);
    }
  };

  const fetchCities = async (stateName) => {
    if (fetchedCitiesStates[stateName]) return;
    try {
      const response = await API.post(
        process.env.REACT_APP_JOBEZEURL + "state-city/list",
        { stateName: stateName }
      );
      setApiData((prevData) => ({
        ...prevData,
        citiesData: response?.data?.message || [],
      }));
      setFetchedCitiesStates((prev) => ({ ...prev, [stateName]: true }));
    } catch (error) {
      console.error("Error fetching cities data", error);
    }
  };
  const validateTab = (tabIndex) => {
    switch (tabIndex) {
      case 0:
        return validateTabOne();
      case 1:
        return validateTabTwo();
      case 2:
        return validateTabThree();
      default:
        return true;
    }
  };

  const handleTabChange = (event, newValue) => {
    if (newValue > tabValue) {
      const isValid = validateTab(tabValue);
      if (!isValid) return;
    }
    setTabValue(newValue);
  };

  const fetchCompaniesData = async () => {
    try {
      const response = await API.get(
        `/job/get-all-employer-companies?emp_id=${formData.user_id}`
      );
      setApiData((prevData) => ({
        ...prevData,
        companiesData: response?.data?.data || [],
      }));
    } catch (error) {
      console.error("Error fetching companies data: ", error);
    }
  };
  const fetchBranchesData = async (company) => {
    try {
      const response = await API.get(
        `/job/get-all-employer-companies-branches?company_id=${
          formData.company || company
        }`
      );
      setApiData((prevData) => ({
        ...prevData,
        branchesData: response?.data?.data || [],
      }));
    } catch (error) {
      console.error("Error fetching branches data: ", error);
    }
  };
  const mapTypeIdToLabel = (typeId) => {
    if (typeId === 1) return "Description";
    if (typeId === 2) return "Numeric";
    if (typeId === 3) return "Yes/No";
    return;
  };

  const fetchEmployerData = async () => {
    try {
      const response = await API.get("employer/get-employer-filter-details");
      setApiData((prevData) => ({
        ...prevData,
        employersName: response?.data?.data || [],
      }));
    } catch (error) {
      console.error("Error fetching employer data:", error);
    }
  };
  const fetchQuestionersData = async () => {
    if (!jobId) return;

    try {
      const res = await API.get(`/job/get-questioners/${jobId}`);
      const { parsedData, hasAnyoneApplied } = res.data.data;
      console.log("Parsed questions:", parsedData);

      if (hasAnyoneApplied < 1) {
        const formattedQuestions = parsedData.map((item) => ({
          question: item.question,
          quesId: item.question_id,
          isCreate: false,
          isEdit: false,
          isDelete: false,
          isChange: true,
          values: [],
          type: mapTypeIdToLabel(item.question_type),
        }));

        setQuestions(formattedQuestions);
      }
    } catch (err) {
      console.error("Failed to fetch questions", err);
    }
  };

  const handleAddJob = async () => {
    try {
      const finalQuestions = questions.map((q) => {
        return {
          id: getTypeIdFromLabel(q.type),
          question: q.question,
          quesId: q.quesId || null,
          isCreate: !!q.isCreate,
          isEdit: !!q.isEdit,
          isDelete: !!q.isDelete,
          isRequired: true,
          values: q.values || [],
        };
      });

      const payload = {
        category: formData.category,
        job_title: formData.jobTitle,
        job_type: formData.jobType,
        no_of_opening: formData.openings,
        duration: formData.duration,
        rate: formData.rate,
        salary: formData.salary,
        min_exp: formData.minexperience,
        max_exp: formData.maxexperience || null,
        workmode: formData.workMode,
        city: formData.city,
        state: formData.state,
        job_desc: formData.description,
        skills: formData.skills,
        internal_notes: formData.notes,
        companyId: formData.company,
        cover_letter_required: formData.coverLetter,
        questionsArray: finalQuestions,
        isPublic: formData.visibility,
        branch_id: formData.branch_id,
        email: formData.email,
        SITE_ID: 1,
      };

      await API.post("/job/create-job-details", payload);
      setSnackbar({
        open: true,
        message: "Job added successfully!",
        severity: "success",
      });
      setTimeout(() => {
        // window.location.reload();
        fetchJobsGridData();
        closePopup();
      }, 2000);
    } catch (error) {
      console.error("Error while adding job ", error);
      setSnackbar({
        open: true,
        message: "Failed to add job",
        severity: "error",
      });
    }
  };

  useEffect(() => {
    if (open && data) {
      fetchCategoriesData();
      fetchStatesData();
      fetchQuestionersData();

      const basicDetails = data.basicDetails || {};
      const otherDetails = data.otherDetails || {};

      const experienceStr = basicDetails["Experience"] || "";
      let minexperience = "";
      let maxexperience = "";

      if (experienceStr.includes("-")) {
        const [min, max] = experienceStr
          .split("-")
          .map((s) => s.replace(/\D/g, "").trim());
        minexperience = min || "";
        maxexperience = max || "";
      } else if (experienceStr.includes("+")) {
        minexperience = experienceStr.replace(/\D/g, "").trim();
        maxexperience = "";
      }

      let city = "";
      let state = "";
      const location = basicDetails["Location"] || "";
      const locationParts = location.split(",");
      if (locationParts.length >= 2) {
        city = locationParts[0].trim();
        state = locationParts[1].trim();
      }

      setFormData((prev) => ({
        ...prev,
        category: basicDetails["Category"] || "",
        jobTitle: basicDetails["Job Title"] || "",
        jobType: jobTypeMapping[basicDetails["Job Type"]] || "",
        openings: basicDetails["Openings"] || "",
        duration: basicDetails["Duration"] || "",
        rate: basicDetails["Max Rate"] || "",
        salary: basicDetails["Salary"] || "",
        minexperience,
        maxexperience,
        workMode: basicDetails["Work Mode"] || "On-Site",
        visibility: otherDetails.visibility || 0,
        city,
        state,
        email: otherDetails["Entered By"] || "",
        description: otherDetails.description || "",
        notes: otherDetails.notes || "",
        coverLetter:
          basicDetails["Cover Letter Required"]?.toLowerCase() === "yes"
            ? 1
            : 0,
        skills: Array.isArray(otherDetails.skills)
          ? otherDetails.skills
          : (otherDetails.skills || "")
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean),
        company: otherDetails.companyId || "",
        branch_id: otherDetails.branchId || "",
        user_id: otherDetails.enteredBy || "",
      }));
      console.log("Set user_id:", otherDetails.enteredBy);
    }
  }, [open]);

  useEffect(() => {
    if (formData.user_id && open) {
      fetchCompaniesData();
      fetchBranchesData();
      fetchCities(formData.state);
      fetchEmployerData();
    }
  }, [formData.user_id, open]);
  useEffect(() => {
    if (open) {
      fetchStatesData();
    }
  }, [open]);

  const handleUpdateJob = async () => {
    try {
      const payload = {
        category: formData.category,
        job_title: formData.jobTitle,
        job_type: formData.jobType,
        no_of_opening: formData.openings,
        duration: formData.duration,
        rate: formData.rate,
        salary: formData.salary,
        min_exp: formData.minexperience,
        max_exp: formData.maxexperience || null,
        workmode: formData.workMode,
        city: formData.city,
        state: formData.state,
        job_desc: formData.description,
        skills: formData.skills,
        internal_notes: formData.notes,
        companyId: formData.company,
        cover_letter_required: formData.coverLetter,
        questionsArray: questions,
        isPublic: formData.visibility,
        branch_id: formData.branch_id,
        email: formData.email,
        SITE_ID: 1,
      };
      await API.post(`/job/update-job-details/${jobId}`, payload);
      setSnackbar({
        open: true,
        message: "Job updated successfully!",
        severity: "success",
      });
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.error("Error while updating job ", error);
      setSnackbar({
        open: true,
        message: "Failed to update job",
        severity: "error",
      });
    }
  };
  const tabContent = {
    0: (
      <>
        <Box sx={{ padding: "24px", height: "417px", overflow: "auto" }}>
          <Box sx={{ marginBottom: "24px" }}>
            <Typography
              sx={{ fontSize: "18px", fontWeight: "600", marginBottom: "16px" }}
            >
              Authority Details
            </Typography>
            <FormControl
              fullWidth
              error={!!errors.employer}
              size="small"
              required
            >
              <Autocomplete
                disabled={!!data}
                options={apiData.employersName}
                getOptionLabel={(option) => option.name}
                value={
                  apiData.employersName.find(
                    (emp) => emp.user_id === formData.user_id
                  ) || null
                }
                onFocus={() => {
                  if (!apiData.employersName.length) fetchEmployerData();
                }}
                onChange={(event, newValue) => {
                  setFormData((prev) => ({
                    ...prev,
                    employer: newValue ? newValue.name : "",
                    email: newValue ? newValue.email : "",
                    user_id: newValue ? newValue.user_id : "",
                    company: "",
                    branch_id: "",
                    branch: "",
                  }));

                  setApiData((prevData) => ({
                    ...prevData,
                    companiesData: [],
                    branchesData: [],
                  }));

                  // if (newValue?.user_id) {
                  //   fetchCompaniesData(newValue.user_id);
                  // }

                  setErrors((prev) => ({
                    ...prev,
                    employer: "",
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Employer"
                    variant="outlined"
                    error={!!errors.employer}
                    helperText={errors.employer}
                    size="small"
                  />
                )}
              />
            </FormControl>
            <Box sx={{ display: "flex", gap: "20px", marginTop: "20px" }}>
              <FormControl size="small" fullWidth error={!!errors.company}>
                <InputLabel>Select Company</InputLabel>
                <Select
                  label="Select Company"
                  name="company"
                  value={formData.company}
                  disabled={!!data || !formData.user_id}
                  error={!!errors.company}
                  onChange={(event) => {
                    const selectedCompany = apiData.companiesData.find(
                      (company) => company.company_id === event.target.value
                    );

                    setFormData((prev) => ({
                      ...prev,
                      company: event.target.value,
                      branch_id: selectedCompany
                        ? selectedCompany.branch_id
                        : "",
                      companyId: "",
                    }));

                    // if(selectedCompany?.branch_id) {
                    //   fetchBranchesData(selectedCompany.branch_id);
                    // }

                    setErrors((prev) => ({
                      ...prev,
                      company: "",
                    }));
                  }}
                  onFocus={fetchCompaniesData}
                >
                  {apiData.companiesData.length > 0 ? (
                    apiData.companiesData.map((company) => (
                      <MenuItem
                        key={company.company_id}
                        value={company.company_id}
                      >
                        {company.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No companies available</MenuItem>
                  )}
                </Select>
                {errors.company && (
                  <FormHelperText>{errors.company}</FormHelperText>
                )}
              </FormControl>

              <FormControl size="small" fullWidth error={!!errors.branch}>
                <InputLabel>Select Branch</InputLabel>
                <Select
                  label="Select Branch"
                  name="branch_id"
                  value={formData.branch_id || ""}
                  disabled={!formData.company}
                  error={!!errors.branch}
                  onChange={(event) => {
                    const selectedBranch = apiData.branchesData.find(
                      (branch) => branch.branch_id === event.target.value
                    );

                    setFormData((prev) => ({
                      ...prev,
                      branch_id: selectedBranch ? selectedBranch.branch_id : "",
                    }));

                    setErrors((prev) => ({
                      ...prev,
                      branch: "",
                    }));
                  }}
                  onFocus={() => fetchBranchesData(formData.company)}
                >
                  {apiData.branchesData.length > 0 ? (
                    apiData.branchesData.map((branch) => (
                      <MenuItem key={branch.branch_id} value={branch.branch_id}>
                        {branch.branch_name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No branches available</MenuItem>
                  )}
                </Select>
                {errors.branch && (
                  <FormHelperText>{errors.branch}</FormHelperText>
                )}
              </FormControl>
            </Box>
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: "600",
                margin: "16px 0px 16px 0px",
              }}
            >
              Job Details
            </Typography>
            <Box display="flex" gap={2} mt={2}>
              <FormControl size="small" fullWidth error={!!errors.category}>
                <InputLabel>Category</InputLabel>
                <Select
                  label="Category"
                  name="category"
                  onChange={handleChange}
                  value={formData.category}
                  onFocus={fetchCategoriesData}
                  error={!!errors.category}
                >
                  {apiData.categoriesData.length > 0 ? (
                    apiData.categoriesData.map((category, index) => (
                      <MenuItem key={index} value={category}>
                        {category}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No categories available</MenuItem>
                  )}
                </Select>
                {errors.category && (
                  <FormHelperText>{errors.category}</FormHelperText>
                )}
              </FormControl>

              <TextField
                fullWidth
                size="small"
                label="Job Title"
                name="jobTitle"
                value={formData.jobTitle}
                onChange={handleChange}
                error={!!errors.jobTitle}
                helperText={errors.jobTitle}
              />
            </Box>
            <Box display="flex" gap={2} mt={2}>
              <FormControl size="small" fullWidth error={!!errors.jobType}>
                <InputLabel>Job Type</InputLabel>
                <Select
                  label="Job Type"
                  value={
                    Object.keys(jobTypeMapping).find(
                      (key) => jobTypeMapping[key] === formData.jobType
                    ) || ""
                  }
                  name="jobType"
                  onChange={handleChange}
                >
                  {Object.keys(jobTypeMapping).map((label) => (
                    <MenuItem key={label} value={label}>
                      {label}
                    </MenuItem>
                  ))}
                </Select>
                {errors.jobType && (
                  <FormHelperText>{errors.jobType}</FormHelperText>
                )}
              </FormControl>

              <TextField
                size="small"
                fullWidth
                label="No. of Openings"
                name="openings"
                value={formData.openings}
                onChange={handleChange}
              />
            </Box>
            <Box display="flex" gap={2} mt={2}>
              <TextField
                size="small"
                fullWidth
                label="Duration"
                name="duration"
                disabled={formData.jobType === "H"}
                value={formData.duration}
                onChange={handleChange}
              />
              <FormControl fullWidth size="small">
                <TextField
                  label="Rate/Hours"
                  name="rate"
                  value={formData.rate}
                  onChange={handleChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  size="small"
                />
              </FormControl>
            </Box>
            <Box display="flex" gap={2} mt={2}>
              <TextField
                fullWidth
                size="small"
                label="Salary/Annum"
                name="salary"
                disabled={formData.jobType !== "H"}
                value={formData.salary}
                onChange={handleChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  ),
                }}
              />
            </Box>
          </Box>
        </Box>
      </>
    ),
    1: (
      <>
        <Box sx={{ padding: "24px", height: "417px", overflow: "auto" }}>
          <Box sx={{ marginBottom: "24px" }}>
            <Typography
              sx={{ fontSize: "18px", fontWeight: "600", marginBottom: "16px" }}
            >
              Experience (Years)
            </Typography>
            <Box display="flex" gap={2} mt={2}>
              <TextField
                sx={{ width: "50%" }}
                label="Minimum Experience"
                size="small"
                name="minexperience"
                value={formData.minexperience}
                onChange={handleChange}
                error={!!errors.minexperience}
                helperText={errors.minexperience}
              />
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <RemoveOutlinedIcon sx={{ color: "#424242", width: "8px" }} />
              </Box>
              <TextField
                sx={{ width: "50%" }}
                label="Maximum Experience"
                size="small"
                name="maxexperience"
                value={formData.maxexperience}
                onChange={handleChange}
                error={!!errors.maxexperience}
                helperText={errors.maxexperience}
              />
            </Box>
          </Box>
          <Box>
            <Typography sx={{ fontSize: "18px", fontWeight: "600" }}>
              Work Mode
            </Typography>
            <Box display="flex">
              <RadioGroup
                row
                sx={{ gap: "30px" }}
                name="workMode"
                value={formData.workMode}
                onChange={handleChange}
              >
                <FormControlLabel
                  value="On-Site"
                  control={<Radio />}
                  label="Onsite"
                  sx={{ marginRight: "0px" }}
                />
                <FormControlLabel
                  value="Hybrid"
                  control={<Radio />}
                  label="Hybrid"
                  sx={{ marginRight: "0px" }}
                />
                <FormControlLabel
                  value="Remote"
                  control={<Radio />}
                  label="Remote"
                  sx={{ marginRight: "0px" }}
                />
              </RadioGroup>
            </Box>
          </Box>
          <Box mt={3}>
            <Typography sx={{ fontSize: "18px", fontWeight: "600" }}>
              Visibility
            </Typography>
            <Box display="flex" gap={2}>
              <FormGroup>
                <FormControlLabel
                  name="visibility"
                  checked={formData.visibility === 1}
                  onChange={handleChange}
                  control={<Checkbox />}
                  label="Public"
                />
              </FormGroup>
            </Box>
          </Box>
          <Box mt={2}>
            <Typography
              sx={{ fontSize: "18px", fontWeight: "600", marginBottom: "16px" }}
            >
              Location
            </Typography>

            <Box sx={{ display: "flex", gap: "20px" }}>
              <FormControl size="small" fullWidth error={!!errors.state}>
                <InputLabel>State</InputLabel>
                <Select
                  label="State"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  // onFocus={fetchStatesData}
                >
                  {apiData.statesData.map((state) => (
                    <MenuItem key={state.name} value={state.name}>
                      {state.name}
                    </MenuItem>
                  ))}
                </Select>
                {errors.state && (
                  <FormHelperText>{errors.state}</FormHelperText>
                )}
              </FormControl>
              <FormControl size="small" fullWidth error={!!errors.city}>
                <InputLabel>City</InputLabel>
                <Select
                  label="City"
                  name="city"
                  value={formData.city}
                  disabled={!formData.state}
                  onChange={handleChange}
                  onFocus={() => fetchCities(formData.state)}
                >
                  {apiData.citiesData.map((city) => (
                    <MenuItem key={city.city} value={city.city}>
                      {city.city}
                    </MenuItem>
                  ))}
                </Select>
                {errors.city && <FormHelperText>{errors.city}</FormHelperText>}
              </FormControl>
            </Box>
          </Box>
        </Box>
      </>
    ),

    2: (
      <>
        <Box sx={{ padding: "24px", height: "417px", overflow: "auto" }}>
          <Box sx={{ marginBottom: "10px" }}>
            <Typography
              sx={{ fontSize: "18px", fontWeight: "600", marginBottom: "10px" }}
            >
              Brief Description
            </Typography>
            <FormControl
              fullWidth
              sx={{
                "& .ql-container": {
                  borderRadius: "0px 0px 4px 4px",

                  height: "150px",
                  border: errors.description
                    ? "1px solid #d32f2f"
                    : "1px solid #ccc",
                },
                "& .ql-toolbar": {
                  borderRadius: "4px 4px 0px 0px",
                  border: errors.description
                    ? "1px solid #d32f2f"
                    : "1px solid #ccc",
                },
              }}
              error={!!errors.description}
            >
              <ReactQuill
                theme="snow"
                placeholder="Write the Description here..."
                value={formData.description}
                onChange={handledescriptionOnChange}
                error={!!errors.description}
              />
              {errors.description && (
                <FormHelperText>{errors.description}</FormHelperText>
              )}
            </FormControl>
          </Box>
          <Box>
            <Typography
              sx={{ fontSize: "18px", fontWeight: "600", marginBottom: "10px" }}
            >
              Skills
            </Typography>

            <FormControl fullWidth error={!!errors.skills} size="small">
              <Autocomplete
                multiple
                freeSolo
                options={skillsOption}
                value={formData.skills || []}
                inputValue={skillInput}
                onInputChange={(event, newInputValue) => {
                  setSkillInput(newInputValue);
                  hanldeSkillInputChange(newInputValue);
                }}
                onChange={(event, newValue) => {
                  setFormData((prev) => ({
                    ...prev,
                    skills: newValue,
                  }));
                  setErrors((prevErrors) => ({
                    ...prevErrors,
                    skills: "",
                  }));
                }}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      label={option}
                      size="small"
                      {...getTagProps({ index })}
                    />
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search and select skills..."
                    error={!!errors.skills}
                    helperText={errors.skills}
                  />
                )}
                filterOptions={(options) => options}
                noOptionsText={
                  skillInput
                    ? "No matching skills found"
                    : "Start typing to search skills"
                }
              />
            </FormControl>
          </Box>
        </Box>
      </>
    ),
    3: (
      <>
        <Box sx={{ padding: "24px", height: "417px", overflow: "auto" }}>
          <Typography
            sx={{ fontSize: "18px", fontWeight: "600", marginBottom: "8px" }}
          >
            Screening Questions
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "400",
              marginBottom: "16px",
              color: "rgba(0, 0, 0, 0.60)",
            }}
          >
            We recommend adding 3 or more questions. Applicants must answer each
            question.
          </Typography>

          {questions.map((q, index) =>
            !q.isDelete ? (
              <Box
                key={index}
                sx={{
                  backgroundColor: "#F5F9FC",
                  borderRadius: "4px",
                  padding: "16px",
                  marginBottom: "16px",
                }}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{ gap: 2, flexWrap: "wrap" }}
                >
                  <FormControl size="small" sx={{ width: "30%" }}>
                    <InputLabel shrink>Type</InputLabel>
                    <Select
                      label="Type"
                      value={q.type}
                      disabled={!q.isCreate}
                      onChange={(e) => {
                        const selectedLabel = e.target.value;
                        updateQuestion(index, "type", selectedLabel);
                        updateQuestion(
                          index,
                          "values",
                          selectedLabel === "Yes/No"
                            ? [
                                { name: "yes", isDefault: true },
                                { name: "no", isDefault: false },
                              ]
                            : []
                        );
                      }}
                    >
                      <MenuItem value="Description">Description</MenuItem>
                      <MenuItem value="Numeric">Numeric</MenuItem>
                      <MenuItem value="Yes/No">Yes/No</MenuItem>
                    </Select>
                  </FormControl>

                  <Box display="flex" alignItems="center" sx={{ flex: 1 }}>
                    <InfoIcon sx={{ fontSize: 25, mr: 0.5 }} />
                    <Typography sx={{ fontSize: "14px", color: "#555" }}>
                      You will get response in {q.type}
                    </Typography>
                  </Box>

                  <IconButton
                    color="error"
                    onClick={() => deleteQuestion(index)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Box>

                <TextField
                  fullWidth
                  multiline
                  placeholder="Write question here"
                  sx={{ marginTop: "12px", backgroundColor: "#fff" }}
                  rows={1}
                  value={q.question}
                  onChange={(e) =>
                    updateQuestion(index, "question", e.target.value)
                  }
                />
              </Box>
            ) : null
          )}

          <Box
            sx={{
              borderRadius: "4px",
              backgroundColor: "#F5F9FC",
              padding: "0px 12px 20px",
            }}
          >
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: "400",
                marginBottom: "16px",
                color: "rgba(0, 0, 0, 0.80)",
                padding: "8px 0px",
              }}
            >
              Add Screening Question
            </Typography>
            <Stack direction="row" spacing={2}>
              <Chip
                label="DESCRIPTION"
                onClick={() => addQuestion("Description")}
                icon={
                  <AddOutlinedIcon
                    style={{ color: "#2196F3", width: "20px", height: "20px" }}
                  />
                }
                variant="outlined"
                sx={{
                  padding: "6px 16px",
                  color: "#2196F3",
                  border: "1px solid #2196F3",
                  fontSize: "14px",
                }}
              />
              <Chip
                label="NUMERIC"
                onClick={() => addQuestion("Numeric")}
                icon={
                  <AddOutlinedIcon
                    style={{ color: "#2196F3", width: "20px", height: "20px" }}
                  />
                }
                variant="outlined"
                sx={{
                  padding: "6px 16px",
                  color: "#2196F3",
                  border: "1px solid #2196F3",
                  fontSize: "14px",
                }}
              />
              <Chip
                label="YES/NO"
                onClick={() => addQuestion("Yes/No")}
                icon={
                  <AddOutlinedIcon
                    style={{ color: "#2196F3", width: "20px", height: "20px" }}
                  />
                }
                variant="outlined"
                sx={{
                  padding: "6px 16px",
                  color: "#2196F3",
                  border: "1px solid #2196F3",
                  fontSize: "14px",
                }}
              />
            </Stack>
          </Box>
          <FormGroup sx={{ margin: "24px 0px" }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.coverLetter === 1}
                  onChange={handleCheckboxChange}
                />
              }
              label="Cover Letter Required"
            />
          </FormGroup>

          <Box>
            <Typography
              sx={{ fontSize: "18px", fontWeight: "600", marginBottom: "14px" }}
            >
              Internal Notes
            </Typography>
            <FormControl fullWidth>
              <Textarea
                placeholder="Write Note Here..."
                minRows={2}
                value={formData.notes || ""}
                name="notes"
                onChange={handleChange}
                sx={{ boxShadow: "none", borderColor: "rgba(0, 0, 0, 0.20)" }}
              />
            </FormControl>
          </Box>
        </Box>
      </>
    ),
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === "backdropClick") return;
        closeForm();
      }}
      disableEscapeKeyDown
      fullWidth
      sx={{ "& .MuiDialog-paper": { borderRadius: "16px" } }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          padding: "16px 24px",
          borderBottom: "1px solid rgba(0, 0, 0, 0.10)",
        }}
      >
        <DialogTitle
          sx={{ flex: 1, fontSize: "22px", fontWeight: "500", padding: "0px" }}
        >
          {data ? "Edit Job" : "Add Job"}
        </DialogTitle>
        <IconButton onClick={closeForm} sx={{ color: "#101828 !important" }}>
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent sx={{ padding: "0px" }}>
        <Box
          sx={{
            width: "100%",
            padding: "10px 24px 0px 24px",
            backgroundColor: "#F7F8FA",
          }}
        >
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            variant="fullWidth"
            sx={{
              "& .MuiTab-root": {
                minWidth: 0,
                padding: "6px 12px",
              },
            }}
          >
            <Tab label="Basic Info" sx={{ fontSize: "14px" }} />
            <Tab label="Experience" sx={{ fontSize: "14px" }} />
            <Tab label="Job Description" sx={{ fontSize: "14px" }} />
            <Tab label="Screening Questions" sx={{ fontSize: "14px" }} />
          </Tabs>
        </Box>
        <Box>{tabContent[tabValue]}</Box>
      </DialogContent>

      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 2,
          width: "100%",
          padding: "16px 24px",
          borderTop: "1px solid rgba(0, 0, 0, 0.10)",
        }}
      >
        {tabValue === 0 && (
          <>
            <Button
              onClick={closeForm}
              variant="outlined"
              sx={{ flex: 1, textTransform: "none", padding: "10px" }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{ flex: 1, textTransform: "none", padding: "10px" }}
              onClick={() => {
                if (validateTab(0)) {
                  setTabValue(1);
                }
              }}
            >
              Next
            </Button>
          </>
        )}
        {tabValue === 1 && (
          <>
            <Button
              onClick={() => setTabValue(0)}
              variant="outlined"
              sx={{ flex: 1, textTransform: "none", padding: "10px" }}
            >
              Back
            </Button>
            <Button
              variant="contained"
              sx={{ flex: 1, textTransform: "none", padding: "10px" }}
              onClick={() => {
                if (validateTab(1)) {
                  setTabValue(2);
                }
              }}
            >
              Next
            </Button>
          </>
        )}
        {tabValue === 2 && (
          <>
            <Button
              onClick={() => setTabValue(1)}
              variant="outlined"
              sx={{ flex: 1, textTransform: "none", padding: "10px" }}
            >
              Back
            </Button>
            <Button
              variant="contained"
              sx={{ flex: 1, textTransform: "none", padding: "10px" }}
              onClick={() => {
                if (validateTab(2)) {
                  setTabValue(3);
                }
              }}
            >
              Next
            </Button>
          </>
        )}
        {tabValue === 3 && (
          <>
            <Button
              onClick={() => setTabValue(2)}
              variant="outlined"
              sx={{ flex: 1, textTransform: "none", padding: "10px" }}
            >
              Back
            </Button>
            <Button
              variant="contained"
              sx={{ flex: 1, textTransform: "none", padding: "10px" }}
              onClick={data ? handleUpdateJob : handleAddJob}
            >
              {data ? "Update" : "Add"}
            </Button>
          </>
        )}
      </DialogActions>
      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      />
    </Dialog>
  );
}
export default AddJob;
